// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { shouldUpdate } from 'recompose';

// Utils
import { sanitiseUrl } from '../../../common/utils/urlUtil';

// Components
import LinkAnchor from './LinkAnchor';

// Styles
import './LinkURL.scss';

const getUrl = (element) => element && element.getIn(['content', 'link', 'url']);

const LinkURL = ({ element }) => {
    const url = getUrl(element);
    return (
        <LinkAnchor className="LinkURL" url={url}>
            <div>{sanitiseUrl(url)}</div>
        </LinkAnchor>
    );
};

LinkURL.propTypes = {
    element: PropTypes.object,
};

// Once rendered this component never needs to update
const enhance = shouldUpdate((props, nextProps) => false);

export default enhance(LinkURL);
